import React from 'react'

const OP = require('object-path'), dayjs = require('dayjs')

const generalKeys = { payload: ['payload', 'Payload'] }

const fns = {
    request: {
        v2lockedspaces: {
            callerName: ['requestContext.callerName', 'Frågare'],
            ...generalKeys
        },
        v2accessrequest: {
            callerName: ['requestContext.callerName', 'Frågare'],
            ...generalKeys,
        },
        v2accesskey: {
            callerName: ['requestContext.callerName', 'Frågare'],
            ...generalKeys,
        }
    },
    response: {
        v2lockedspaces: {
            ...generalKeys
        },
        v2accessrequest: {
            ...generalKeys
        },
        v2accesskey: {
            ...generalKeys
        }
    }
}

const transform = (conf, data) => {
    const fields = []

    for (var key in conf) {
        const [path, label] = conf[key]

        fields.push({ label, value: OP.get(data, path) })
    }

    return fields
}

export const requestTransformer = (request) => {
    const conf = fns.request[request.lambdaFn]

    return transform(conf, request)
}

export const responseTransformer = (response) => {
    const conf = fns.response[response.lambdaFn]

    return transform(conf, response)
}


const dayjsFormat = "DD/MM HH:mm"

const columns = {
    date: self => {
        return {
            Header: "Datum:",
            id: 'date',
            Cell: ({ original }) => {
                return (
                    <div>
                        {dayjs(original.date).format(dayjsFormat)}
                    </div>
                )
            },
            maxWidth: 100
        }
    },
    callerName: self => {
        return {
            Header: 'Frågare/transp.:',
            id: 'callerName',
            filterMethod: (filter, row) => {
                const rq = row._original.requestContext
                if (!rq || !rq.callerName) return false

                return rq.callerName.toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            },
            Cell: ({ original }) => {
                return (
                    <div>
                        {original.requestContext.callerName}
                    </div>
                )
            },
            maxWidth: 150
        }
    },
    vendorName: self => {
        return {
            Header: 'Butik:',
            id: 'vendorName',
            accessor: d => d.payload.requestor.shipperName,
            maxWidth: 150
        }
    },
    lock: self => {
        return {
            Header: 'Lås:',
            id: 'lock',
            accessor: d => {
                let lock
                try {
                    const publicId = d.virtualLockId.split('-')[0]
                    lock = self.props.sesamLockDescriptions[publicId]

                    if (!lock) return "Lås ej på detta konto"
                } catch (e) {
                    console.log(e)
                    return "Kan ej fastställa id"
                }

                return lock.custom_name
            },
            maxWidth: 150
        }
    },
    request: self => {
        return {
            Header: "Request:",
            id: 'request',
            filterMethod: (filter, row) => self.defaultFilterMethod(filter, row._original.payload),
            Cell: ({ original, index }) => {
                return (
                    <div onMouseEnter={() => self.setState({ enteredCellIndex: index })} onMouseLeave={(e) => { self.setState({ enteredCellIndex: null }) }}>
                        {self.state.enteredCellIndex === index ? self.renderInnerText('request', original) : self.renderCell(original.payload)}
                    </div>
                )
            }
        }
    },
    response: self => {
        return {
            Header: "Response:",
            id: 'response',
            filterMethod: (filter, row) => self.defaultFilterMethod(filter, row._original.response),
            Cell: ({ original, index }) => {
                return (
                    <div onMouseEnter={() => self.setState({ enteredCellIndex: index })} onMouseLeave={(e) => { self.setState({ enteredCellIndex: null }) }}>
                        {self.state.enteredCellIndex === index ? self.renderInnerText('response', original) : self.renderCell(original.response)}
                    </div>
                )
            }
        }
    },
    traceId: self => {
        return {
            Header: 'Tråd',
            id: 'traceid',
            filterMethod: (filter, row) => self.defaultFilterMethod(filter, row._original.virtualLockId),
            Cell: ({ original }) => {
                let publicId
                try {
                    publicId = original.virtualLockId.split('-')[0]
                } catch (e) {
                    console.log(e)
                    return ""
                }

                const lock = self.props.sesamLockDescriptions[publicId] || {}

                return (
                    <div>
                        {original.virtualLockId ? <p className="HotspotterLink" onClick={() => self.props.onThreadClick(original.virtualLockId, lock)}>Öppna tråd</p> : 'Ingen tråd'}
                    </div>
                )
            },
            maxWidth: 100
        }
    }, log: self => {
        return {
            Header: 'Log',
            id: 'log',
            Cell: ({ original }) => {
                const rq = original.requestContext

                if (!rq.logGroupName || !rq.logStreamName || !rq.correlationId) return ''

                return (
                    <div>
                        <span className="HotspotterLink" style={{ color: 'blue' }} onClick={() => self.props.onViewLogClick(rq)}>Se logg</span>
                    </div>
                )
            },
            maxWidth: 100
        }
    }
}

export const tableColumnHelper = (self, requestName) => {
    const cols = []
    try {
        for (var columnName of requestColumns[requestName]) {
            const col = columns[columnName]
            if (col === undefined) return alert(`${columnName} hittades inte i columns!!!!`)

            cols.push(columns[columnName](self))
        }

        return cols
    } catch (e) {
        console.log(e)
        return []
    }
}

const requestColumns = {
    lockedspaces: 'date.callerName.request.response.log'.split('.'),
    accessrequest: 'date.callerName.vendorName.lock.request.response.traceId.log'.split('.'),
    accesskey: 'date.callerName.lock.request.response.traceId.log'.split('.'),
    accessevent: 'date.callerName.lock.request.response.traceId.log'.split('.'),
    lockedspaceposition: 'date.callerName.lock.request.response.traceId.log'.split('.'),
    revokeaccess: 'date.callerName.lock.request.response.traceId.log'.split('.'),
    accessdeviation: 'date.callerName.lock.request.response.traceId.log'.split('.'),

    threads: 'date.callerName'.split('.')
}
